<template>
  <v-footer padless id="common-footer">
    <v-card flat tile class="text-center" width="100%">
      <v-divider></v-divider>
      <slot name="sns-share"></slot>
      <CompanyInformation></CompanyInformation>
      <ContactButton></ContactButton>
      <CopyRight></CopyRight>
    </v-card>
  </v-footer>
</template>

<script>
import CompanyInformation from "@/components/Common/CompanyInformation";
import CopyRight from "@/components/Common/CopyRight";
import ContactButton from "@/components/Common/ContactButton";

export default {
  name: "Footer",
  components: {
    ContactButton,
    CopyRight,
    CompanyInformation
  }
};
</script>

<style lang="scss" scoped>
* {
  font-family: $footer-font-family;
}
</style>
